module.exports = __webpack_public_path__ + "static/media/91.78a3bcda.jpg";